import React from "react";

import Form from "@Components/Form";
import { BANNER_URL } from "configs/constants";

const initialValues = {
  banner_type: "IAB",
  title: "",
  description: "",
  call_to_action: false,
  url: "",
  image: null,
  is_active: false,
  display_start_date: null,
  display_start_time: null,
};

const BannerViewDetails = () => {
  const formFields = [
    {
      type: "renderonly",
      name: "is_active",
      key: "is_active",
      label: "Is Active?",
      valueType: "boolean",
      yesValue: "Yes",
      noValue: "No",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "banner_type",
      key: "banner_type",
      label: "Banner Type",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "title",
      key: "title",
      label: "Banner Title",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "imagerender",
      name: "image",
      key: "image",
      label: "Image",
      showText: "Banner Image",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "display_start_date",
      key: "display_start_date",
      label: "Display Start Date",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "display_start_time",
      key: "display_start_time",
      label: "Display Start Time",
      valueType: "date_time",
      parseTimeOnly: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "description",
      key: "description",
      label: "Description",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 12 },
    },
    {
      type: "renderonly",
      name: "call_to_action",
      key: "call_to_action",
      label: "Call to action?",
      valueType: "boolean",
      yesValue: "Yes",
      noValue: "No",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "url",
      key: "url",
      requiredValidation: "call_to_action",
      renderKey: "call_to_action",
      renderValue: true,
      label: "URL",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
  ];

  const formButtons = ["cancel"];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={BANNER_URL}
      listRoute="/announcement/banner/banner"
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Banner"
      isMultipart
      noListButton
    />
  );
};

export default BannerViewDetails;
